import { useCallback, useMemo, useState } from 'react';
import { map } from 'lodash';
import { useCampaignGroupsFetchService } from 'modules/campaigns/components/EntityPicker/services/useCampaignGroupsFetchService';
import { useFormDataContext } from 'modules/taboola-common-frontend-modules/formData';

export const DEFAULT_SELECTED_CAMPAIGN_GROUPS = [];

export const useCampaignGroupDropdownData = (campaignGroups = DEFAULT_SELECTED_CAMPAIGN_GROUPS) => {
    const {
        formAccount: { accountName },
    } = useFormDataContext();
    const { loadCampaignGroups } = useCampaignGroupsFetchService({ accountName });
    const [rawOptions, setOptions] = useState([]);
    const options = useMemo(() => {
        const campaignGroupsSet = new Set(map(campaignGroups, 'id'));
        return rawOptions.map(option => option || {}).filter(option => !campaignGroupsSet.has(option?.value));
    }, [rawOptions, campaignGroups]);
    const loadPage = useCallback(
        async ({ page, pageSize, searchText }) => {
            const [results, total] = await loadCampaignGroups({ page, pageSize, searchText });
            const list = results.map(({ id: value, name: label, status }) => ({ value, label, status }));

            return [list, total, results.length - list.length];
        },
        [loadCampaignGroups]
    );

    return { options, setOptions, loadPage };
};
